import { fbDatabase } from 'src/boot/firebase'
import { Notify } from 'quasar'
import { logIt } from './function-logger';

export function setDbChild (payload) {
  if(import.meta.env.DEV) console.log('setDbChild', { payload });
  if(!payload.data){
    if (import.meta.env.DEV) console.log('WHATAHELL!!! - payload.data required');
    return
  }

  let fbRef = fbDatabase.ref(payload.path);
  fbRef.set(payload.data, error => {
    if (error) {
      logIt({type: 'error', error, text: error.message, path: payload.path})
    } else {
      if (payload.message) Notify.create(payload.message)
    }
  });
}

export function setDbChildAsync(payload) {
  if (import.meta.env.DEV) console.log('setDbChild', { payload });
  if (!payload.data) {
    if (import.meta.env.DEV) console.log('WHATAHELL!!! - payload.data required');
    return;
  }

  return new Promise((resolve, reject) => {
    let fbRef = fbDatabase.ref(payload.path);
    fbRef.set(payload.data, error => {
      if (error) {
        logIt({type: 'error', error, text: error.message, path: payload.path})
        reject(error);
      } else {
        if (payload.message) Notify.create(payload.message);
        resolve();
      }
    });
  });
}

export function fetchDbChildAsync(payload) {
  if (import.meta.env.DEV) console.log('fetchDbChild', { payload });

  return new Promise((resolve, reject) => {
    let fbRef = fbDatabase.ref(payload.path);

    fbRef.once(
      'value',
      snapshot => {
        resolve(snapshot.val());
      }, error => {
        if (error) {
          reject(error);
        }
      }
    );
  });
}

export function updateDbChild (payload) {
  if(import.meta.env.DEV) console.log('updateDbChild', { payload });
  if(!payload.data){
    if (import.meta.env.DEV) console.log('WHATAHELL!!! - payload.data required');
    return
  }

  let fbRef = fbDatabase.ref(payload.path);
  fbRef.update(payload.data, error => {
    if (error) {
      logIt({type: 'error', error, text: error.message, path: payload.path})
    } else {
      if (payload.message) Notify.create(payload.message);
    }
  });
}

export function pushDbChild (payload, _message) {
  if(import.meta.env.DEV) console.log('pushDbChild', payload.path);

  let fbRef = fbDatabase.ref(payload.path);
  var newChildRef = fbRef.push();

  newChildRef.set(payload.data, error => {
    if (error) {
      logIt({type: 'error', error, text: error.message, path: payload.path})
    } else {
      if (_message) Notify.create(_message);
    }
  }
  );
}

export function fetchDbChild (path, _message, _on_error_to) {
  if(import.meta.env.DEV) console.log('fetchDbChild', { path });

  let fbRef = fbDatabase.ref(path);

  fbRef.once("value", snapshot => {
    return snapshot.val()


  }, error => {
    if (_message) Notify.create(error);
    if (_on_error_to) {
      this.$router.replace(_on_error_to)
    }
  }
  );
}

export function deleteDbChild (payload) {
  if(import.meta.env.DEV) console.log('deleteDbChild', { payload });

  if(!payload.path){
    if (import.meta.env.DEV) console.log('WHATAHELL!!! - payload.path required');
    return
  }

  fbDatabase.ref(payload.path).remove( error => {
    if (error) {
      logIt({type: 'error', error, text: error.message, path: payload.path})
    } else {
      if (payload.message) Notify.create(payload.message);
    }
  }
  );
}

export function deleteDbChildAsync(payload) {
  if (import.meta.env.DEV) console.log('deleteDbChildAsync', { payload });

  if (!payload.path) {
    if (import.meta.env.DEV) console.log('WHATAHELL!!! - payload.path required');
    return Promise.reject('path required')
  }

  return new Promise((resolve, reject) => {
    fbDatabase.ref(payload.path).remove((error) => {
      if (error) {
        logIt({type: 'error', error, text: error.message, path: payload.path})
        reject(error)
      } else {
        if (payload.message) Notify.create(payload.message)
        resolve()
      }
    })
  })
}

export function incrementDbChild (payload, _message) {
  if(import.meta.env.DEV) console.log('incrementDbChild', { payload });

  fbDatabase.ref(payload.path).transaction((post) => {
    return (post || 0) + (payload.count || 1);
  });
}
